'use client';

import type { ImageVisualBlock } from '@jeraisonne/ai/visual-blocks';

export function ImageVisualBlockRenderer({ block }: { block: ImageVisualBlock }) {
  return (
    <img
      src={block.src}
      alt={block.alt ?? block.caption ?? block.title ?? ''}
      className="mx-auto h-auto max-h-[360px] w-full max-w-lg rounded-lg object-contain"
      loading="lazy"
    />
  );
}
